<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span class="mt-1.5 text-xl font-medium"
                >{{ shared?.datosUser?.nombre }}...</span
            >
            <span class="mt-1.5 text-md font-medium">{{
                shared?.datosUser?.email
            }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item [routerLink]="'/perfil'">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{ "MI_PERFIL" | translate }}</span>
    </button>
    <button mat-menu-item (click)="openDialogChangePassword()">
        <mat-icon [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
        <span>{{ "CAMBIAR_CONTRASENA" | translate }}</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="languageMenu">
        <mat-icon>language</mat-icon>
        <span>{{ "IDIOMA" | translate }}</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>{{ "CERRAR_SESION" | translate }}</span>
    </button>
</mat-menu>

<mat-menu class="language-menu" #languageMenu="matMenu">
    <button mat-menu-item (click)="cambiarIdioma('es')">
        <img
            src="assets/images/flags/mexico.png"
            alt="México"
            style="width: 24px; margin-right: 8px"
        />
        <span>{{ "ESPANOL" | translate }}</span>
    </button>
    <button mat-menu-item (click)="cambiarIdioma('en')">
        <img
            src="assets/images/flags/usa.png"
            alt="USA"
            style="width: 24px; margin-right: 8px"
        />
        <span>{{ "INGLES" | translate }}</span>
    </button>
</mat-menu>
